export default class AdwordsGoogleMaxPerformance {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  // BUMPER and SKIPPABLE
  async getGoogleSearch(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    customerId
  ) {
    try {
      const googleSearch = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL_GOOGLE}/adwords/PERFORMANCE_MAX/${customerId}/businesses/${businessUnitId}?fromDate=${fromDate}&toDate=${toDate}`
      );

      return {
        ...googleSearch.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  // PAGES
  async getGoogleSearchPages(subscriberId, businessUnitId, fromDate, toDate) {
    try {
      const googleSearch = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/summary-pages/business/${businessUnitId}/${subscriberId}?toDate=${toDate}&fromDate=${fromDate}`
      );

      return {
        ...googleSearch.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }
}
